'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getStepOptions;

var _StepsConfigContainer = require('../globals/StepsConfigContainer');

var _StepsConfigContainer2 = _interopRequireDefault(_StepsConfigContainer);

var _immutable = require('immutable');

var _Logger = require('../lib/Logger');

var _Logger2 = _interopRequireDefault(_Logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOG = _Logger2.default.getLogger('utils/getStepOptions');

function getStepOptions(stepKey) {
  var stepKeys = _StepsConfigContainer2.default.get();
  if (!stepKeys) {
    LOG.error('Unable to get step options, no step keys conf available ', {
      extra: {
        stepKey: stepKey
      }
    });
  }
  return stepKeys ? stepKeys.get(stepKey) || (0, _immutable.Map)() : (0, _immutable.Map)();
}
module.exports = exports['default'];